import { render, staticRenderFns } from "./ReportBox.vue?vue&type=template&id=24f4b459"
import script from "./ReportBox.vue?vue&type=script&lang=js"
export * from "./ReportBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports